<template>
    <div id="apricationQQ">
        <div class="headerp-div">
            <div class="header-div">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :key="crumbs" v-for="crumbs in $crumbsList()">{{crumbs}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="header-div" style="text-align: right">
                <div style="float: right">
                    <el-button size="mini" @click="handleCurrentChange()"
                               style="background-color:#409EFF;color: white;margin-right: 5px;">
                        查询<i class="el-icon-search"></i>
                    </el-button>
                </div>
                <div style="float: right">
                    <el-date-picker
                            @change="dateChang"
                            v-model="dateValues"
                            class="queryPzDate"
                            type="monthrange"
                            value-format="yyyy-MM"
                            align="right"
                            size="mini"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始月份"
                            end-placeholder="结束月份"
                            :picker-options="pickerOptions">
                    </el-date-picker>
                </div>
            </div>
        </div>

        <el-table
                :data="tableData"
                height="520"
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'left'}"
                size="mini"
                style="width: 100%; margin-bottom: 20px;"
                row-key="dicCode"
                :tree-props="{children: 'children'}">
            <el-table-column
                    width="220"
                    prop="dicCode"
                    label="科目编码"
                    align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.children.length==0 && scope.row.dicCode != null">
                        {{scope.row.dicCode}}
                    </span>
                    <span v-else style="color: #3cbaff">{{scope.row.dicCode}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    width="320"
                    label="科目名称"
                    align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.levelNum=='2'" style="padding-left: 20px;">{{scope.row.dicName}}</span>
                    <span v-else-if="scope.row.levelNum=='3'" style="padding-left: 40px;">{{scope.row.dicName}}</span>
                    <span v-else-if="scope.row.levelNum=='4'" style="padding-left: 60px;">{{scope.row.dicName}}</span>
                    <span v-else-if="scope.row.levelNum=='5'" style="padding-left: 80px;">{{scope.row.dicName}}</span>
                    <span v-else-if="scope.row.levelNum=='6'" style="padding-left: 100px;">{{scope.row.dicName}}</span>
                    <span v-else-if="scope.row.levelNum=='7'" style="padding-left: 120px;">{{scope.row.dicName}}</span>
                    <span v-else-if="scope.row.levelNum=='8'" style="padding-left: 140px;">{{scope.row.dicName}}</span>
                    <span v-else-if="scope.row.levelNum=='10'" style="padding-left: 160px;">{{scope.row.dicName}}</span>
                    <span v-else-if="scope.row.levelNum=='12'" style="padding-left: 180px;">{{scope.row.dicName}}</span>
                    <span v-else>{{scope.row.dicName}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    class-name="ctcss"
                    width="66"
                    label="明细"
                    align="center">
                <template slot-scope="scope">
                    <a class="kmdmCss" @click="handleMx(scope.row)">
                        <svg t="1687916448962" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2354" width="20" height="20"><path d="M147.968 291.84h749.568a66.048 66.048 0 0 0 40.448-56.32 43.52 43.52 0 0 0-40.448-46.08H147.968a43.52 43.52 0 0 0-40.448 46.08 51.2 51.2 0 0 0 11.776 32.256c7.68 8.704 17.92 13.312 28.672 24.064zM388.096 445.44H147.968a40.96 40.96 0 0 0-40.448 44.032 70.656 70.656 0 0 0 40.448 58.368h240.128a71.68 71.68 0 0 0 40.448-58.368 40.96 40.96 0 0 0-40.448-44.032zM345.6 701.44H147.968a37.888 37.888 0 0 0-40.448 41.984 76.8 76.8 0 0 0 40.448 60.416h197.632a77.824 77.824 0 0 0 40.448-60.416 38.4 38.4 0 0 0-40.448-41.984zM828.928 692.224a204.8 204.8 0 0 0 27.648-102.4 186.368 186.368 0 0 0-175.104-194.56 186.368 186.368 0 0 0-175.616 194.56 185.856 185.856 0 0 0 175.616 194.56 158.208 158.208 0 0 0 89.6-28.672l87.552 97.28a38.4 38.4 0 0 0 57.344 0 47.616 47.616 0 0 0 11.776-31.744 46.08 46.08 0 0 0-11.776-31.744z m-53.76-102.4a102.4 102.4 0 0 1-93.696 102.4 102.4 102.4 0 0 1-94.208-102.4 99.328 99.328 0 0 1 94.208-102.4 99.328 99.328 0 0 1 93.696 101.376z" p-id="2355" fill="#1296db"></path></svg>
                    </a>
                </template>
            </el-table-column>
            <el-table-column label="期初余额（元）" align="center">
                <el-table-column
                        class-name="ricss"
                        prop="qiChuValueJie"
                        align="center"
                        label="借方">
                </el-table-column>
                <el-table-column
                        class-name="ricss"
                        prop="qiChuValueDai"
                        align="center"
                        label="贷方">
                </el-table-column>
            </el-table-column>

            <el-table-column label="本期发生额（元）" align="center">
                <el-table-column
                        class-name="ricss"
                        prop="bqfsValueJie"
                        align="center"
                        label="借方">
                </el-table-column>
                <el-table-column
                        class-name="ricss"
                        prop="bqfsValueDai"
                        align="center"
                        label="贷方">
                </el-table-column>
            </el-table-column>

            <el-table-column label="本年累计发生额（元）" align="center">
                <el-table-column
                        class-name="ricss"
                        prop="bnljValueJie"
                        align="center"
                        label="借方">
                </el-table-column>
                <el-table-column
                        class-name="ricss"
                        prop="bnljValueDai"
                        align="center"
                        label="贷方">
                </el-table-column>
            </el-table-column>

            <el-table-column label="期末余额（元）" align="center">
                <el-table-column
                        class-name="ricss"
                        prop="qiMoValueJie"
                        align="center"
                        label="借方">
                </el-table-column>
                <el-table-column
                        class-name="ricss"
                        prop="qiMoValueDai"
                        align="center"
                        label="贷方">
                </el-table-column>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
    export default {
        name: 'kmyebiaoList',
        data() {
            return {
                tableData: [],
                startTimeStr: null,
                endTimeStr: null,
                pickerOptions: {
                    shortcuts: [{
                        text: '本月',
                        onClick(picker) {
                            picker.$emit('pick', [new Date(), new Date()]);
                        }
                    }, {
                        text: '上月',
                        onClick(picker) {
                            let date = new Date();
                            // 2.获取今日的年月
                            let year = date.getFullYear();
                            let month = date.getMonth();
                            const end = new Date(year, month - 1, 1);
                            const start = new Date(year, month - 1, 1);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                dateValues: []
            }
        },
        methods: {
            dateChang() {
                if (this.dateValues != null && this.dateValues.length > 0) {
                    this.startTimeStr = this.dateValues[0];
                    this.endTimeStr = this.dateValues[1];
                } else {
                    this.startTimeStr = null;
                    this.endTimeStr = null;
                }
            },
            handleCurrentChange() {
                this.tableData = [];
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/mingXiZhang/kmYeList?td=' + new Date()),
                    method: 'get',
                    params: {
                        'startTimeStr': this.startTimeStr,
                        'endTimeStr': this.endTimeStr
                    }
                }).then(r => {
                    if (r.data.code == 0) {
                        this.tableData = r.data.data.dataList;
                        this.dateValues = r.data.data.dateValues;
                    } else {
                        this.$message({
                            type: 'error',
                            message: r.data.msg
                        })
                    }
                }).finally(r => {
                })

            },
            handleMx(row) {
                let kmdm = row.dicCode;
                let kmmc = row.dicName;
                this.$router.push({
                    path: '/home-mxz/list',
                    query: {
                        kmdm: kmdm,
                        kmmc: kmmc,
                        dateValues: this.dateValues
                    }
                })
            }
        },
        created: function () {
            this.handleCurrentChange();
        }
    }
</script>
<style scoped>
    .header-div {
        margin-bottom: 5px;
        float: left;
        width: 50%;
    }

    .queryInput >>> .el-input__inner {
        border-radius: 0px;
        width: 200px;
    }

    .el-collapse-item div {
        padding-left: 20px;
        padding-bottom: 15px;
    }

    .kmdmCss {
        color: #3cbaff;cursor: pointer;
    }

    #apricationQQ >>> .el-table--border td, .el-table--border th {
        border-right: 1px solid #ddd !important;
    }

    #apricationQQ >>> .el-table--border th {
        border-right: 1px solid #ddd !important;
        border-top: 1px solid #ddd !important;
    }

    #apricationQQ >>> .el-table td, .el-table th.is-leaf {
        border-bottom: 1px solid #ddd !important;
    }

    #apricationQQ >>> .el-table th.is-leaf {
        border-bottom: 1px solid #ddd !important;
    }

    #apricationQQ >>> .el-table {
        border-right: 1px solid #ddd !important;
        border-left: 1px solid #ddd !important;
    }

    .queryPzDate {
        margin-right: 5px;
    }

    #apricationQQ >>> tbody .ricss {
        text-align: right !important;
    }
    #apricationQQ >>> tbody .ctcss {
        text-align: center !important;
    }
</style>